// eslint-disable-next-line no-unused-vars
import { post, get } from '@/utils/http'
export default {
  /**
   * 登录 api
   * @param params username, password
   * @returns {*}
   */
  postLogin (params) {
    return post('/user/userLogin', params)
  },
  /**
   * 注册
   * @param params username password rePassword name
   * @returns {*}
   */
  postRegister (params) {
    return post('/user/userRegister', params)
  },
  /**
   * 用户列表
   * @param params
   * @returns {*}
   */
  getUserList (params) {
    return get('/user/user_list', params)
  },
  getUserInfo (params) {
    return get('/user/user_info', params)
  },
  postModifyUserInfo (params) {
    return post('/user/modify_Info', params)
  },
  postDelUser (params) {
    return post('/user/del_user', params)
  },
  /**
   * 工具
   * @param params
   * @returns {*}
   */
  postToolList (params) {
    return get('/tools/tools_list', params)
  },
  postDownCount (params) {
    return post('/tools/down_count', params)
  },
  postFriendLink (params) {
    return get('/publicRouter/friend_link', params)
  },
  /**
   * 记账
   */
  getAccountList (params) {
    // 获取记录列表
    return get('/account/account_list', params)
  },
  getAccountTypeList (typeClass) {
    // 获取记账类型列表   typeClass 入账：in，出账：out  不传默认为所有
    return get(`/account/account_type_list/${typeClass}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js